import React, {useEffect, useState} from 'react';
import {Link, useParams} from 'react-router-dom';
import AdminMenu from "../AdminMenu";
import AdminHeader from "../AdminHeader";
import axios from "axios";
import ReactPaginate from "react-paginate";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faAdd, faCode, faSadCry} from "@fortawesome/free-solid-svg-icons";
import {ADMIN_API_BASE} from "../../../utils/apiConfig";
import convertCourseIdToName from "../../../utils/conversions";
import ButtonLink from "../../../components/elements/ButtonLink";

const AdminCheatsheetList = () => {
    const [cheatsheets, setCheatsheets] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [courseId, setCourseId] = useState(useParams().course_id);

    const getCsrfToken = async () => {
        try {
            const response = await fetch(`${ADMIN_API_BASE}/csrf-token`, {
                method: "GET",
                credentials: "include",
            });
            const data = await response.json();
            return data.csrfToken;
        } catch (error) {
            console.error('Error fetching CSRF token:', error);
            return null;
        }
    };

    useEffect(() => {
        const fetchCheatsheets = async () => {
            const token = await getCsrfToken();
            try {
                const response = await axios.get(`${ADMIN_API_BASE}/${courseId}/cheatsheet/`, {
                    withCredentials: true,
                    headers: {
                        'csrf-token': token,
                    },
                });
                if (response.data.success) {
                    setCheatsheets(response.data.cheatsheets);
                }
            } catch (error) {
                console.error('There was a problem with the axios request:', error);
            }
        };

        fetchCheatsheets();
    }, []);

    const handleModalClose = () => {
        setIsModalOpen(false);
    };

    const handleDeleteClick = (id) => {

    }

    return (
        <>
            <div className="flex flex-1">
                <div className="flex flex-1">
                    <div className='w-1/5'>
                        <AdminMenu path='./'/>
                    </div>
                    <div className='flex-grow w-4/5'>
                        {/*<AdminHeader title={` تقلب‌نامه‌ی ${convertCourseIdToName(cheatsheets.course_id, 'fa')}`} />*/}
                        <AdminHeader title={` تقلب‌نامه‌ی`}/>
                        <div className="gap-4 py-3 px-10 flex-1 my-10">
                            <ButtonLink className='gap-3' to={`/admin/${courseId}/cheatsheet/new/`}>
                                <FontAwesomeIcon icon={faAdd} size="lg"/>
                                <span>افزودن</span>
                            </ButtonLink>
                            <div className='w-full flex gap-5 py-10 flex-wrap'>
                                {cheatsheets && cheatsheets.length > 0 && cheatsheets.map(cheatsheet => (
                                    <div key={cheatsheet.id} className="w-1/5">
                                        <Link to={`/admin/${cheatsheet.course_id}/cheatsheet/${cheatsheet.id}`}
                                              className="block">
                                            <div
                                                className="bg-white p-5 shadow-md rounded-sm transition hover:bg-gray-100 hover:-translate-y-2">
                                                <h2 className="text-md line-clamp-2 mb-5">{cheatsheet.id}</h2>
                                            </div>
                                        </Link>
                                        <button
                                            className="bg-red-400 rounded-sm px-3 py-2 mt-2"
                                            onClick={() => handleDeleteClick(cheatsheet.id)}>
                                            حذف
                                        </button>
                                    </div>
                                ))}
                            </div>
                            {
                                cheatsheets && cheatsheets.length === 0 && (
                                    <div className="w-full flex items-center flex-col gap-8 justify-center p-10">
                                        <FontAwesomeIcon icon={faSadCry} className='h-20'/>
                                        <h2>هیچ محتوایی پیدا نشد!</h2>
                                    </div>
                                )
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AdminCheatsheetList;